/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_StorefrontInputs */

const en_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Storefront`)
};

const es_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar tienda`)
};

const fr_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer la vitrine`)
};

const de_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront verwalten`)
};

const ja_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントを管理`)
};

const zh_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理店铺`)
};

const ar_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة واجهة المتجر`)
};

const id_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola Etalase`)
};

const it_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci Vetrina`)
};

const ru_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление витриной`)
};

const pt_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar Vitrine`)
};

const ko_manage_storefront = /** @type {(inputs: Manage_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 관리`)
};

/**
* | output |
* | --- |
* | "Manage Storefront" |
*
* @param {Manage_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const manage_storefront = /** @type {((inputs?: Manage_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_storefront(inputs)
	if (locale === "es") return es_manage_storefront(inputs)
	if (locale === "fr") return fr_manage_storefront(inputs)
	if (locale === "de") return de_manage_storefront(inputs)
	if (locale === "ja") return ja_manage_storefront(inputs)
	if (locale === "zh") return zh_manage_storefront(inputs)
	if (locale === "ar") return ar_manage_storefront(inputs)
	if (locale === "id") return id_manage_storefront(inputs)
	if (locale === "it") return it_manage_storefront(inputs)
	if (locale === "ru") return ru_manage_storefront(inputs)
	if (locale === "pt") return pt_manage_storefront(inputs)
	return ko_manage_storefront(inputs)
});